import { render } from "./DisabledSelect.vue?vue&type=template&id=76de6961"
import script from "./DisabledSelect.vue?vue&type=script&lang=ts"
export * from "./DisabledSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script